<template>
    <div>
        <div class="modal fade" id="exampleModalCenter" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">{{nombre_region}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="modal__contenedor_imagen_y_ajustador">
                            <img class="modal__contenedor_imagen_y_ajustador--imagen" v-bind:src="require(`@/assets/imagenes/seccionFoprovep/${imagen_region}`)">
                            <!-- Datos de los ajustadores) -->
                            <div class="modal__contenedor_imagen_y_ajustador--ajustador">
                                <h5 class="modal__contenedor_imagen_y_ajustador--titulo">Ajustadores:</h5>
                                <div v-for="(ajustador, a) in datos_region" :key="a">        
                                    <div v-for="(datos_ajustador, b) in ajustador.ajustadores" :key="b">
                                        <!-- {{datos_ajustador}} -->
                                        <p class="modal__contenedor_imagen_y_ajustador--ajustador_nombre">{{datos_ajustador.nombre}}</p>
                                        <p v-show="datos_ajustador.tel_oficina" class="modal__contenedor_imagen_y_ajustador--ajustador_tel">Oficina: {{datos_ajustador.tel_oficina}}</p>
                                        <p v-show="datos_ajustador.tel_celular" class="modal__contenedor_imagen_y_ajustador--ajustador_tel">Celular: {{datos_ajustador.tel_celular}}</p>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                        <!-- Listado de municipios -->
                        <div class="modal__contenedor_municipios">
                            <div v-for="(municipio, c) in datos_region" :key="c">
                                <div v-for="(datos_municipios, d) in municipio.municipios" :key="d">
                                    <p class="modal__contenedor_municipios--lista">
                                      <span class="modal__contenedor_municipios--lista_clave">{{datos_municipios.clave}} -</span>{{datos_municipios.nombre_municipio}}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    created(){
    },
    props:{
        nombre_region:"",
        imagen_region:"",
        datos_region:{}
    },
}
</script>
<style scoped>
.modal{z-index: 3000;}
.modal-dialog {max-width: 850px;}
.modal-body{
    background-image: url('../../../assets/imagenes/seccionFoprovep/fondo.svg');
    padding: 3rem;
}
.modal__contenedor_imagen_y_ajustador{
    display: flex;
}
.modal__contenedor_imagen_y_ajustador--imagen{
    width: 75%;
}

.modal__contenedor_imagen_y_ajustador--titulo{
    font-size: 1.6rem;
}
.modal__contenedor_imagen_y_ajustador--ajustador_nombre{
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 0.3rem;
    font-size: 1.15rem;
}
.modal__contenedor_imagen_y_ajustador--ajustador_tel{
    margin-bottom: 0;
}
.modal__contenedor_municipios--lista{
    margin-bottom: 0;
    font-size: 1.25rem;
    font-weight: 400;
    color: #621132;
}
.modal__contenedor_municipios--lista_clave{
    color: #1d1d1b;
    font-weight: 500;
}
/* estilos para moviles */
@media only screen and (max-device-width : 900px){
    .modal { z-index: 2000; }
    .modal-content { height: auto; } /*| celulares grandes = 100vh |*/
    .modal-content2 { height: auto; } /*|celulares pqños    |*/
    .modal-dialog { margin: 0; }


    .btn.focus, .btn:focus {
        outline: 0;
        box-shadow: none;
    }

    .modal-header h5{
        color: #b3b3b3;
        letter-spacing: 1px;
    }

    /* ESTILOS PARA EL CONTENIDO DEL MODAL */
    .modal-body{padding: 1rem;}
    .modal__contenedor_imagen_y_ajustador{
        display: flex;
        flex-direction: column;
    }
    .modal__contenedor_imagen_y_ajustador--imagen{
        width: 100%;
    }
    .modal__contenedor_municipios{
        margin-top: 1rem;
    }
}

</style>